import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FlaskService } from 'src/app/flask.service';
import { JavaService } from 'src/app/java.service';

@Component({
    selector: 'app-enter-pin',
    templateUrl: './enter-pin.component.html',
    styleUrls: ['./enter-pin.component.css']
})
export class EnterPinComponent implements OnInit {

    private pin = '';

    constructor(
        private _java: JavaService,
        private _router: Router,
        private _flask: FlaskService,
    ) { }

    async ngOnInit() {
        const pin = await this._flask.getPin();

        if (pin.length) {
            // store to check entry
            this.pin = pin;
        } else {
            // then empty and force setting of pin
            this._router.navigate(['/tr/choose-pin']);
        }
    }

    onBack() {
        this._java.javaConnector.goBack();
    }

    onEnter(pin: string) {
        if (pin === this.pin) {
            this._java.javaConnector.gotoTRAdmin();
        } else {
            this._router.navigate(['/tr/pin-incorrect']);
        }
    }
}
